<template>
	<UserDetails
		v-if="user"
		route-name="admin-users-details"
		:route-params="{ id: userId }"
		:title="`User: ${user.email}`"
		:user-id="userId" />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useUserDetailsState } from '@/models/User/States'
import UserDetails from '@/views/User/Details.vue'

const route = useRoute()
const router = useRouter()
const userId = computed(() => Number(route.params.id))
const detailsState = useUserDetailsState()
const user = computed(() => detailsState.details.value)

watch(
	userId,
	async () => {
		try {
			await detailsState.getDetails(userId.value)
		} catch {
			router.replace({ name: 'admin-users-list' })
		}
	},
	{ immediate: true },
)
</script>
